module.exports = __webpack_public_path__ + "img/avatar1.1b7a0a8a.png";